export default function (trigger, config) {
    const params = {};
    Object.entries(trigger.params || {}).forEach(([name, value]) => {
        if (config.schema?.[name]?.type === 'string' && typeof value === 'number') {
            params[name] = String(value);
        }
        else if (config.schema?.[name]?.type === 'number' && !isNaN(Number(value))) {
            params[name] = Number(value);
        }
        else {
            params[name] = value;
        }
    });
    return {
        name: trigger.name,
        params,
        isNonInteractive: Boolean(config.nonInt),
    };
}
